export function LoadMore({ loading, onLoadMore }: { loading: boolean; onLoadMore: () => Promise<void> }) {
  return (
    <div className="row" style={{ justifyContent: 'center' }}>
      <button type="button" className="secondary" disabled={loading} onClick={() => void onLoadMore()}>
        {loading ? 'Loading…' : 'Load more'}
      </button>
    </div>
  );
}
